import { Close } from "@mui/icons-material";
import {
  Box,
  IconButton,
  Skeleton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SearchSection from "components/my-listing/search-input";
import RentalBookingTypes from "components/personal-rental/rental-booking-status";
import ListItem from "components/personal-rental/rental-item";
import { BOOKING_STATUS, RENTAL_API_TYPE } from "constants/general";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPersonalRentalList } from "slices/personalRentalReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import useQuery from "utils/router.util";

const PersonalRentalPage = () => {
  const dispatch = useAppDispatch();
  const query: any = useQuery();
  const navigate = useNavigate();
  const { personalRentalReducer } = useAppSelector((state) => state);
  const { list, loadingList } = personalRentalReducer;
  const [searchString, setSearchString] = useState("");
  const [showSearh, setShowSearch] = useState(false);

  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesXs = useMediaQuery(theme.breakpoints.only("xs"));

  const type: any = query.get("type");
  useEffect(() => {
    const page: any = query.get("page") || 1;
    const type: any = query.get("type")
      ? BOOKING_STATUS[query.get("type")]
      : BOOKING_STATUS.PENDING;

    dispatch(
      getPersonalRentalList({
        requestType: RENTAL_API_TYPE.RENTAL,
        page: Number(page),
        type: Number(type),
        search: searchString,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, searchString]);

  return (
    <Box>
      <Box
        sx={{
          display: {
            md: "flex",
            lg: "flex",
            xl: "flex",
            sm: "flex",
            xs: "flex",
          },
          px: "4%",
          py: "20px",
          borderBottom: "1px solid #F4F4F4",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            flex: 2,
          }}
        >
          <img
            src="/assets/img/icons/arrow_left.svg"
            alt=""
            width="24px"
            height="24px"
            onClick={() => navigate("/cart")}
          />
          <Typography
            sx={{
              color: "#323232",
              fontWeight: 600,
              fontSize: "24px",
              lineHeight: "35px",
            }}
          >
            Booking History
          </Typography>
        </Box>

        <Box
          sx={{
            display: {
              md: "flex",
              lg: "flex",
              xl: "flex",
              sm: "none",
              xs: "none",
            },
            flex: 1,
          }}
        >
          <SearchSection
            placeholder="Search your order here…"
            onChange={({ target }: any) => {
              setSearchString(target.value);
            }}
          />
        </Box>

        <IconButton
          sx={{
            display: {
              md: "none",
              lg: "none",
              xl: "none",
              sm: "flex",
              xs: "flex",
            },
          }}
          onClick={() => {
            if (showSearh) {
              setSearchString("");
            }
            setShowSearch(!showSearh);
          }}
        >
          {!showSearh ? (
            <img
              src="/assets/img/icons/search_b.svg"
              width="24px"
              height="24px"
              alt=""
            />
          ) : (
            <Close />
          )}
        </IconButton>

        {showSearh && (matchesSm || matchesXs) && (
          <Box
            sx={{
              display: {
                md: "flex",
                lg: "flex",
                xl: "flex",
                sm: "flex",
                xs: "flex",
              },
              position: "absolute",
              zIndex: 5,
              background: "#FFF",
              flex: 1,
              width: "80%",
            }}
          >
            <SearchSection
              placeholder="Search your order here…"
              onChange={({ target }: any) => {
                setSearchString(target.value);
              }}
            />
          </Box>
        )}
      </Box>

      <Box>
        <RentalBookingTypes />
      </Box>
      <Box
        sx={{
          px: "4%",
          py: "20px",
          display: "flex",
          gap: "20px",
          flexDirection: "column",
        }}
      >
        {!loadingList &&
          list.map((l: any) => <ListItem data={l} bookingId={l.id} />)}
        {loadingList &&
          [1, 2, 3, 4, 5].map(() => (
            <Box>
              <Skeleton variant="rectangular" height="100px" width="100%" />
            </Box>
          ))}
      </Box>
      {!loadingList && list.length === 0 && (
        <Box
          sx={{
            mx: "4%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "90%",
            my: "8%",
          }}
        >
          <img src="/assets/img/no-data-cat.png" alt="" width="271px" />
          <Typography
            sx={{
              color: "#323232",
              fontWeight: 700,
              fontSize: "26px",
              lineHeight: "31px",
              mt: "20px",
              mb: "10px",
              textAlign: "center",
            }}
          >
            No{" "}
            {type === "requested"
              ? "Requested"
              : type === "confirmed"
              ? "Confirmed"
              : type === "completed"
              ? "Completed"
              : type === "cancelled"
              ? "Cancelled"
              : "Requested"}{" "}
            Bookings Yet!
          </Typography>
          <Typography
            sx={{
              color: "#A2A2A2",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "24px",
              mb: "15px",
              textAlign: "center",
            }}
          >
            Currently, there are no confirmed bookings in your account. Stay
            tuned <br />
            for future updates!
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PersonalRentalPage;
